/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyResponseWithDetails = {
    properties: {
        id: {
    type: 'number',
},
        questionId: {
    type: 'number',
},
        answerText: {
    type: 'string',
    isNullable: true,
},
        answerBool: {
    type: 'boolean',
    isNullable: true,
},
        answerOptionId: {
    type: 'number',
    isNullable: true,
},
        answerRating: {
    type: 'number',
    isNullable: true,
},
        answerOptionIds: {
    type: 'array',
    contains: {
    type: 'number',
},
    isNullable: true,
},
        skipQuestion: {
    type: 'boolean',
},
        createdAt: {
    type: 'string',
    format: 'date-time',
},
        optionLabel: {
    type: 'string',
    isNullable: true,
},
        selectedLabels: {
    type: 'array',
    contains: {
    type: 'string',
},
},
    },
};